(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-atf"] && !Shopify.designMode) return;
  try {
    
  class ProductLuxuryATF extends HTMLElement {
    constructor() {
      super();
      this.heroContainer = this.querySelector('.product-atf__hero-container');
      this.heroImage = this.querySelector('.product-atf__hero-image');
      this.heroOverlay = this.querySelector('.product-atf__hero-container .product-atf__media-overlay');
      this.thumbnails = this.querySelectorAll('.product-atf__thumbnail');
      this.lightbox = this.querySelector('.product-atf__lightbox');
      this.lightboxImage = this.querySelector('.product-atf__lightbox-image');
      this.lightboxClose = this.querySelector('.product-atf__lightbox-close');
      this.addBtns = this.querySelectorAll('.product-atf__btn');

      // Listen for changes on the container (Event Delegation)
      this.addEventListener('change', this.onVariantChange.bind(this));

      this.initGalleryListeners();
      this.initQuantityListeners();
    }

    initQuantityListeners() {
      const quantityInputs = this.querySelectorAll('.quantity-input');

      quantityInputs.forEach((container) => {
        const btns = container.querySelectorAll('.quantity-input__btn');
        const input = container.querySelector('.quantity-input__field');
        const changeEvent = new Event('change', { bubbles: true });

        btns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const previousValue = input.value;

            if (btn.name === 'plus') {
              input.stepUp();
            } else if (btn.name === 'minus') {
              input.stepDown();
            }

            if (previousValue !== input.value) {
              input.dispatchEvent(changeEvent);
            }

            this.validateQuantityBtns(container);
          });
        });

        // Initial validation
        this.validateQuantityBtns(container);
      });
    }

    validateQuantityBtns(container) {
      const input = container.querySelector('.quantity-input__field');
      const value = parseInt(input.value);
      const minusBtn = container.querySelector("[name='minus']");
      const plusBtn = container.querySelector("[name='plus']");

      if (input.min) {
        minusBtn.classList.toggle('disabled', value <= parseInt(input.min));
      }
      if (input.max) {
        plusBtn.classList.toggle('disabled', value >= parseInt(input.max));
      }
    }

    initGalleryListeners() {
      // Thumbnail Click & Keydown
      this.thumbnails.forEach((thumb) => {
        const handleSelect = () => {
          this.updateHero(thumb.dataset.fullSrc, thumb.dataset.mediaId, thumb.dataset.alt, thumb.dataset.variantTitle);
        };
        thumb.addEventListener('click', handleSelect);
        thumb.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSelect();
          }
        });
      });

      // Hover Zoom (Pan effect)
      if (this.heroContainer) {
        this.heroContainer.addEventListener('mousemove', this.onHeroHover.bind(this));
        this.heroContainer.addEventListener('mouseleave', () => {
          this.heroImage.style.transformOrigin = 'center center';
        });

        // Lightbox Open
        this.heroContainer.addEventListener('click', this.openLightbox.bind(this));
        // Keyboard support for Hero Lightbox Trigger
        this.heroContainer.setAttribute('tabindex', '0');
        this.heroContainer.setAttribute('role', 'button');
        this.heroContainer.setAttribute('aria-label', 'Zoom image');
        this.heroContainer.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.openLightbox();
          }
        });
      }

      // Lightbox Close
      if (this.lightboxClose) {
        this.lightboxClose.addEventListener('click', () => this.lightbox.close());
      }
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) this.lightbox.close();
        });
      }
    }

    onHeroHover(e) {
      const { left, top, width, height } = this.heroContainer.getBoundingClientRect();
      const x = ((e.clientX - left) / width) * 100;
      const y = ((e.clientY - top) / height) * 100;

      this.heroImage.style.transformOrigin = `${x}% ${y}%`;
    }

    openLightbox() {
      if (!this.lightbox) return;
      this.lightboxImage.src = this.heroImage.src;
      this.lightboxImage.alt = this.heroImage.alt;
      this.lightbox.showModal();
    }

    updateHero(src, mediaId, altText, variantTitle) {
      console.log('[ATF] updateHero called with title:', variantTitle);
      // Update Image - IMPORTANT: Clear srcset to force browser to use new src
      this.heroImage.removeAttribute('srcset');
      this.heroImage.src = src;
      if (altText) this.heroImage.alt = altText;

      // Update Overlay
      if (this.heroOverlay) {
        this.heroOverlay.textContent = variantTitle || '';
        this.heroOverlay.style.display = variantTitle ? '' : 'none';
      }

      console.log('[ATF] Hero image src set to:', src);
      // Active State
      this.thumbnails.forEach((t) => {
        t.classList.toggle('is-active', t.dataset.mediaId === mediaId);
      });
    }

    onVariantChange(evt) {
      // 1. Filter: Only run if the change came from a variant input
      if (!evt.target.matches('.product-atf__variant-input')) return;

      const variantRadios = this.querySelector('variant-radios');
      if (!variantRadios) return;

      const script = variantRadios.querySelector('script');
      if (!script) return;

      const variants = JSON.parse(script.textContent);
      const fieldsets = Array.from(variantRadios.querySelectorAll('fieldset'));

      const selectedOptions = fieldsets.map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      // 2. Find matching variant
      const currentVariant = variants.find((v) => {
        return v.options.every((val, i) => val === selectedOptions[i]);
      });

      if (currentVariant) {
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', currentVariant.id);
        window.history.replaceState({}, '', url);

        // Update Buttons
        this.addBtns.forEach((btn) => {
          const text = btn.querySelector('.btn-text');
          if (currentVariant.available) {
            btn.removeAttribute('disabled');
            text.textContent = 'Add to Cart';
          } else {
            btn.setAttribute('disabled', 'disabled');
            text.textContent = 'Sold Out';
          }
        });

        // Update Hidden Input
        this.querySelectorAll('input[name="id"]').forEach((input) => (input.value = currentVariant.id));

        // Update Gallery Hero using pre-computed map
        const mapScript = this.querySelector('#VariantMediaMap-' + this.dataset.sectionId);
        if (mapScript) {
          try {
            const variantMediaMap = JSON.parse(mapScript.textContent);
            const mediaIdStr = variantMediaMap[currentVariant.id.toString()];

            console.log('[ATF] Variant changed:', currentVariant.id, '-> Media ID:', mediaIdStr);

            if (mediaIdStr) {
              const matchedThumb = Array.from(this.thumbnails).find((t) => t.dataset.mediaId === mediaIdStr);

              if (matchedThumb) {
                console.log('[ATF] Found matching thumbnail, updating hero');
                this.updateHero(
                  matchedThumb.dataset.fullSrc,
                  mediaIdStr,
                  matchedThumb.dataset.alt,
                  currentVariant.title
                );
              } else {
                console.warn('[ATF] No thumbnail found for media ID:', mediaIdStr);
              }
            }
          } catch (e) {
            console.error('[ATF] Error parsing variant media map:', e);
          }
        }
      }
    }
  }
  customElements.define('product-luxury-atf', ProductLuxuryATF);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-luxury"] && !Shopify.designMode) return;
  try {
    
  class ProductLuxurySection extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.variantRadios = this.querySelector('variant-radios');
      this.addBtns = this.querySelectorAll('.product-luxury__add-to-cart');
      this.priceParts = this.querySelectorAll('.price-money');
      this.stickyBar = this.getElementById(`StickyBar-${this.sectionId}`);
      this.mainFormBtn = this.querySelector('.product-luxury__form button[type="submit"]');

      this.initVariantChange();
      this.initMobileSticky();
      this.initMobileScroll();
    }

    getElementById(id) {
      return this.querySelector(`#${id}`) || document.getElementById(id); // Fallback for fixed elements
    }

    initVariantChange() {
      if (!this.variantRadios) return;
      this.variantRadios.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      const variants = JSON.parse(this.variantRadios.querySelector('script').textContent);
      const fieldsets = Array.from(this.variantRadios.querySelectorAll('fieldset'));

      // Build selected options array
      const selectedOptions = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      // Find matching variant
      const currentVariant = variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          return optionValue === selectedOptions[index];
        });
      });

      if (currentVariant) {
        this.updateURL(currentVariant);
        this.updatePrice(currentVariant);
        this.updateImage(currentVariant);
        this.updateButtons(currentVariant, true);
        this.updateHiddenInput(currentVariant);
      } else {
        this.updateButtons(null, false);
      }
    }

    updateURL(variant) {
      if (!variant) return;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    updatePrice(variant) {
      // Basic formatting - in production requires a money formatter util
      // assuming theme has a currency format or we just swap the raw cents for now demo
      // Best practice: Use theme's Global JS currency formatter if available.
      // Fallback: simple replace if same length/structure or just text.
      // For this strict output, we'll try to use Shopify's formatMoney if defined, or just update raw HTML if clean.

      const newPrice = (variant.price / 100).toFixed(2); // Simplified
      // Real impl would require fetching section rendering API to get formatted money
      // But for "Javascript" block strictness without jQuery, we often fetch the section.

      // OPTION: Fetch the Section Rendering API to get updated HTML for price
      const url = `${this.dataset.url}?variant=${variant.id}&section_id=${this.sectionId}`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newPriceSource = html.getElementById(`Price-${this.sectionId}`);
          const currentPriceTarget = this.getElementById(`Price-${this.sectionId}`);
          if (newPriceSource && currentPriceTarget) {
            currentPriceTarget.innerHTML = newPriceSource.innerHTML;
          }
        });
    }

    updateImage(variant) {
      if (!variant.featured_media) return;
      const mediaId = variant.featured_media.id;
      const mediaItem = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (mediaItem) {
        mediaItem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
      }
    }

    updateButtons(variant, isAvailable) {
      const btnText = isAvailable ? (variant.available ? 'Add to cart' : 'Sold out') : 'Unavailable';

      this.addBtns.forEach((btn) => {
        const textSpan = btn.querySelector('.btn-text') || btn;
        textSpan.textContent = btnText;

        if (!isAvailable || !variant.available) {
          btn.setAttribute('disabled', 'disabled');
        } else {
          btn.removeAttribute('disabled');
        }
      });
    }

    updateHiddenInput(variant) {
      const forms = this.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (input) input.value = variant.id;
      });
    }

    initMobileSticky() {
      if (!this.stickyBar || !this.mainFormBtn) return;

      // Click proxy
      const stickyBtn = this.stickyBar.querySelector('.sticky-trigger');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          this.mainFormBtn.click();
        });
      }

      // Intersection Observer
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.stickyBar.classList.add('is-visible');
            } else {
              this.stickyBar.classList.remove('is-visible');
            }
          });
        },
        { rootMargin: '100px 0px 0px 0px' }
      );

      observer.observe(this.mainFormBtn);
    }

    initMobileScroll() {
      const gallery = this.querySelector('.product-luxury__media-gallery');
      const counter = this.querySelector('.current-slide');
      if (!gallery || !counter) return;

      gallery.addEventListener(
        'scroll',
        () => {
          // Debounce optimization could go here
          const index = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
          counter.textContent = index;
        },
        { passive: true }
      );
    }
  }

  customElements.define('product-luxury-section', ProductLuxurySection);

  class VariantRadios extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('variant-radios', VariantRadios);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 400px 0px',
      });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
